import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HuvudB2 } from '../interfaces/huvudB2.interface';
import { FiliDb } from '../interfaces/filiDb.interface';
import { Arende } from '../interfaces/arende.interface';

@Component({
    template: `
    <div class="modal-header">
      <p class="modal-title"><fa-icon [icon]="['fas', 'copy']" class="me-2" [fixedWidth]="true"></fa-icon>Bilagor till {{ arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2 {{ arende.galdenar.namn }} {{ b2.datum | localizeddate:'shortDate' }}</p>
      <button type="button" class="btn-close" [attr.aria-label]="'button.stang' | translate" (click)="activeModal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <ul class="list-group list-group-flush">
        @for (file of getAttachmentFiles() | orderBy: 'beskrivning':'case-insensitive'; track file) {
          <li class="list-group-item">
            <file-link [file]="file" [caption]="file.beskrivning || file.filnamn" (onSuccess)="closeModal()"></file-link>
          </li>
        }
      </ul>
    </div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NgbdB2BilagorModal {

  @Input() public b2: HuvudB2;
  @Input() public arende: Arende;

  constructor(public activeModal: NgbActiveModal) {
  }

  private closeModal() {
    this.activeModal.close();
  }

  public getAttachmentFiles(): FiliDb[] {
    return this.b2.filer.filter(f => f.id !== this.b2.fil.id);
  }
}
